import { Dispatch, FC, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { LangConstant } from "@/const";
import { AppDialog } from "@/components/common";
import SelectedFiles from "@/components/common/dialog/ImportDialog/SelectedFiles";

type InternalImportDialogProps = {
  onImport: () => void;
  filesUpload: File[];
  openUpload: boolean;
  onChangeOpenUpload: Dispatch<SetStateAction<boolean>>;
};

const InternalImportDialog: FC<InternalImportDialogProps> = ({
  onImport,
  filesUpload,
  openUpload,
  onChangeOpenUpload,
}) => {
  const { t: getLabel } = useTranslation(LangConstant.NS_REQUEST);

  return (
    <AppDialog
      open={openUpload}
      title={getLabel("OBJ_INTERNAL_IMPORT.title")}
      onClose={() => {
        onChangeOpenUpload(false);
      }}
      ConfirmButtonProps={{
        label: getLabel("L_CONFIRM"),
        onClick: onImport,
      }}
      CancelButtonProps={{
        label: getLabel("L_CANCEL"),
      }}
    >
      <Typography variant="subtitle1">{getLabel("OBJ_INTERNAL_IMPORT.listImport")}</Typography>
      <SelectedFiles files={filesUpload} showFile />
    </AppDialog>
  );
};
export default InternalImportDialog;
